import { render } from "./AddOnAdditionalManifest.vue?vue&type=template&id=a7701fd0"
import script from "./AddOnAdditionalManifest.vue?vue&type=script&lang=js"
export * from "./AddOnAdditionalManifest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__